import React, { useCallback } from 'react';

import { getAnalytics, logEvent } from 'firebase/analytics';

import { ErrorBoundary } from 'react-error-boundary';
import { AdManagerWrapper } from './adManagerWrapper';

export const AdManager = () => {
    const handeOnError = useCallback((error: Error, info: { componentStack: string; }) => {
        const analytics = getAnalytics?.();
            
        if (!analytics) {
            return;
        }
        logEvent?.(analytics, 'legacy_xandr_ad_manager_critical_error', {
            message: error?.message
        });
    }, []);
    return (
        <ErrorBoundary onError={handeOnError} fallback={<span></span>}>
            <AdManagerWrapper />
        </ErrorBoundary>
    );
};

AdManager.displayName = 'AdManager';